module.exports = __webpack_public_path__ + "static/media/avatar42.015e7693.png";